// UI chrome strings for the simulator live in the translation JSON files under
// the `Simulator` namespace (src/translation/*.json). Pack content stays
// bilingual (en/ua) inside each pack; `L()` picks the current language from
// those maps and falls back to English for every other site language.
import i18n from 'i18next';
import { getLanguage } from 'translation';

export const lang = () => (getLanguage() === 'ua' ? 'ua' : 'en');

// Pick the current language from a { en, ua } map. Strings pass through.
export const L = (v) => {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  return v[lang()] ?? v.en ?? '';
};

// t('stepOf', { i: 2, n: 8 }) → localized string. Keys that hold arrays or
// maps (introBullets, urgency, traits, formats) are returned as-is.
export const t = (key, vars) =>
  i18n.t(`Simulator.${key}`, { ...(vars || {}), returnObjects: true });
